import ReactRenderer from "modules/_react-renderer";
import MediaSelector from "./app/mediaSelector";

import "widgets/mtt-react-counter";
import "widgets/mtt-sustainability-tool";
// import "widgets/mtt-financial-analysis-tool";

ReactRenderer.registerComponent("MediaSelector", MediaSelector);

ReactRenderer.render();
